import React from "react";
import ReactDOM from "react-dom";
import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import { connect } from "react-redux";
import FormError from "../../../FormError";
import Modal from '../../../Modal';


import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js';

import {
    addPhoneRecipient,
    addSMSKeywordRecipient,
    updateModalContent,
    removePhoneRecipient,
    formatPhone,
    formatPhoneNatOrIntl,
    cleanPhone,
} from "../../../redux/FeedbackRedux";

class KeywordPhoneRecipients extends React.Component {
  constructor(props) {
    super(props);
    this.state = { phone: "", name: "", "phone_error":false };

    this.handleAddPhoneRecipient = this.handleAddPhoneRecipient.bind(this);
  }

  handleSelectExisting(){
    var modal_id = "addExistingSMSRecipient";
    var modal_title =  __("Text Message Recipients");
    var modal_body = "potentialRecipientsSMS";
    var button_1_class = "outline-secondary";
    var button_1_id = "cancel";
    var button_1_text =  __("Cancel");
    var button_2_class = "primary d-none";
    var button_2_id = "none";
    var button_2_text = "none";
    this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
    jQuery('.modal:not(.error)').modal();
  }

  handleAddPhoneRecipient(event) {

    var phone = parsePhoneNumberFromString(this.state.phone,"US");

    if(!phone || !phone.isValid())
    {
      this.setState({"phone_error": __("Please enter a valid phone number.")});
      return;
    }
    if (this.props.phone_recipients.map((item, key) => item.phone).includes(phone.format("E.164")))
    {
      this.setState({ "phone_error":  __("This phone number is already in the list.") });
      return;
    }

    this.props.dispatch(addSMSKeywordRecipient(this.state));

    this.setState({ phone: "", name: "" });
  }

  handleRemovePhoneRecipient(uuid, event) {
    event.preventDefault();
    this.props.dispatch(removePhoneRecipient({ uuid: uuid }));
    $('button[type=submit]').removeAttr('disabled');
  }

  handleKeyDown(event) {
    var update = event.target.value;

    if (this.state.phone.length < update.length) {
      update = formatPhone(update);
    }

    this.setState({
      phone: update,
      "phone_error":false
    });
  }

  render() {
    return (
      <div className="card">
        <div className="title border rounded px-3 py-3">
        <h5 className="d-flex align-items-center mb-3"><span>{ __('Text Messages') }:</span> <span className="ml-auto btn btn-sm btn-secondary btn-outline-primary" onClick={this.handleSelectExisting.bind(this)}>{ __('Add Existing User') }</span></h5>
          <p className="">
            { __('Users can receive a text message whenever Feedbacks or chat messages with certain keywords are submitted for this business. The text will include the keywords used, along with a link to view the Feedback.') }
          </p>

          <div className="card-body row mt-3">
            <div className="col-sm-6 px-2">
              <div className="input-group feedback-form-control mb-2">
                <input
                  placeholder="Phone Number"
                  type="phone"
                  className="form-control input"
                  name="phone"
                  value={this.state.phone}
                  onChange={this.handleKeyDown.bind(this) }
                  onKeyPress={e => {if(e.key === "Enter"){e.preventDefault();this.handleAddPhoneRecipient();}}}
                ></input>
              </div>
              <FormError error_message={this.state.phone_error}></FormError>
            </div>

            <div className="col-sm-6 px-2">
              <div className="input-group feedback-form-control mb-2">
                <input
                  placeholder={__("Recipient First and Last Name")}
                  type="text"
                  className="form-control input"
                  name="recipient_name"
                  value={this.state.name}
                  onChange={event =>
                    this.setState({ name: event.target.value })
                  }
                  onKeyPress={e => {if(e.key === "Enter"){e.preventDefault();this.handleAddPhoneRecipient();}}}
                ></input>
              </div>
            </div>
        </div>
            <div className="d-flex justify-content-between filter-bar-wrapper-reverse">
                <h5>{ __('Phone Number List: (click on a contact to remove them from the list)') }</h5>
                <a
                    className="btn btn-sm btn-primary text-white d-inline-block mb-1"
                    onClick={this.handleAddPhoneRecipient}
                >
                    <i className="fas fa-inbox-in mr-1"></i> { __('Add Phone Number To List') }
                </a>
            </div>

          <div className="row">
            <div className="col-sm-12">
              {this.props.phone_recipients.map((item, key) => (
                  <div className="d-inline-block mr-2 mb-2" key={item.uuid}>
                    <a
                      href=""
                      className="btn btn-outline-primary btn-sm"
                      onClick={this.handleRemovePhoneRecipient.bind(
                        this,
                        item.uuid
                      )}
                    >
                      <i
                        className="fas fa-user-times mr-1"
                        aria-hidden="true"
                      ></i>{" "}
                      {formatPhoneNatOrIntl(item.phone)} {item.recipient_name?"("+item.recipient_name+")":""}
                    </a>
                    <br></br>
                    <br></br>
                  </div>
              ))}

              {this.props.phone_recipients.length == 0 ? (
                <div>{ __('Empty') }</div>
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
        <input
          type="hidden"
          name="phone_recipients"
          value={JSON.stringify(this.props.phone_recipients)}
        ></input>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    phone_recipients: state.phone_recipients
  };
}

export default connect(mapStateToProps)(KeywordPhoneRecipients);
